import { HTTP, authHeader } from './http-service';

class EEICLAApiKeyService {
  getAll() {
    return HTTP.get('/EEICLAApiKey/all', {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  create(payload) {
    return HTTP.post('/EEICLAApiKey', payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  delete(tmApiKey) {
    return HTTP.delete(`/EEICLAApiKey/${encodeURIComponent(tmApiKey)}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }
}

export default new EEICLAApiKeyService();
